import React from "react";
import Helmet from "react-helmet";
import { Link } from "@reach/router";

import Navigation from "../../components/WaveNavigation";
import PageHeader from "../../components/PageHeader";

import ServiceNotice from "../../components/ServiceNotice";
import PassengerFreightPolicy from "../../components/PassengerFreightPolicy";
import FreightRestrictions from "../../components/FreightRestrictions";
import NewSchedule from "../../components/NewSchedule";
import {
  Schedule,
  Panel,
  Line,
  Trip,
  Note,
  SpecialSchedule,
  Legend,
  LegendItem,
  CircleItem,
  StarItem,
  SquareItem,
  DiamondItem,
  Alert,
} from "../../components/Schedule";
import Amenities from "../../utils/amenities";

import terminalMap from "../../assets/img/terminalMapBW.png";

const beach = "Ocean Beach";

export default () => (
  <div>
    <Helmet
      title="Fire Island Ferries | Ocean Beach Schedule"
      meta={[
        {
          name: "description",
          content:
            "Even though it’s only a short distance from Manhattan, Fire Island is a world away from the hustle and bustle of city life. Boasting 32 miles of pristine beaches, Fire Island offers visitors an escape from mainland pressures with beautiful Atlantic Ocean beaches, calming views of the Great South Bay, and access to peaceful wilderness.",
        },
        {
          name: "keywords",
          content: "Fire Island, New York, Long Island, Ferries, Water Taxi",
        },
      ]}
    />
    <Navigation />
    <div className="container p-0">
      <PageHeader beach={beach}>
        <h2>Schedules</h2>
        <h1>{beach}</h1>

        <div className="d-print-none">
          <p>Amenities</p>
          <div className="amenities">
            {Amenities.byBeach(beach).map((item) => (
              <i
                key={item.text}
                className={`icon-${item.icon}`}
                title={item.text}
              />
            ))}
          </div>
          <div>
            <Link
              className="btn btn-outline-light"
              to="/communities/ocean-beach"
            >
              Information
            </Link>
            &nbsp;&nbsp;
            <Link className="btn btn-outline-light" to="/directory">
              Directory
            </Link>
          </div>
        </div>
      </PageHeader>
    </div>
    <NewSchedule />
    <Schedule
      beach={beach}
      season="Fall Schedule"
      year="2026"
      start="October 13"
      end="November 8"
      download="https://fimedia.s3.us-east-1.amazonaws.com/13OCT26AllTerminals-WEBv2-15OCT26.pdf"
    >
      <Panel title="Monday-Thursday" beach={beach}>
        <Line>
          <Trip BS time="7:00am" />
          <Note />
          <Trip FI time="7:40am" />
        </Line>
        <Line>
          <Trip BS time="10:00am" />
          <Note />
          <Trip FI time="10:40am" />
        </Line>
        <Line>
          <Trip BS time="12:30pm" />
          <Note />
          <Trip FI time="1:20pm" />
        </Line>
        <Line>
          <Trip BS time="3:30pm" />
          <Note />
          <Trip FI time="4:10pm" />
        </Line>
        <Line>
          <Trip BS time="5:35pm" />
          <Note leftArrow rightArrow text="Last Trip 10/15" />
          <Trip FI time="6:25pm" />
        </Line>
      </Panel>
      <Panel title="Friday-Sunday" beach={beach}>
        <Line>
          <Trip BS time="7:00am" />
          <Note leftArrow rightArrow text="Fri. & Sat. Only" />
          <Trip FI time="7:40am" />
        </Line>
        <Line>
          <Trip BS time="10:10am" />
          <Note />
          <Trip FI time="10:50am" />
        </Line>
        <Line>
          <Trip BS time="12:30pm" />
          <Note />
          <Trip FI time="1:00pm" />
        </Line>
        <Line>
          <Trip BS time="3:30pm" />
          <Note />
          <Trip FI time="4:20pm" />
        </Line>
        <Line>
          <Trip BS time="5:35pm" />
          <Note leftArrow rightArrow text="Last Trip 10/31" />
          <Trip FI time="6:25pm" />
        </Line>
        <Line>
          <Trip BS time="7:30pm" />
          <Note leftArrow rightArrow text="Fri. Only, Last Trip 10/30" />
          <Trip FI time="8:10pm" />
        </Line>
      </Panel>
    </Schedule>

    <Schedule
      beach={beach}
      season="Lat Fall Schedule"
      year="2026"
      start="November 9"
      end="December 31"
      download="https://fimedia.s3.us-east-1.amazonaws.com/9NOV26-31DEC26-AllTerminals-WEBv1-28OCT26.pdf"
      alert={
        <>
          <Alert icon="fa fa-exclamation-triangle" danger>
            No passenger service Christmas or New Year's Day
          </Alert>
        </>
      }
    >
      <Panel
        title="Monday-Friday"
        note="Except Thanksgiving Day, 11/26"
        beach={beach}
      >
        <Line>
          <Trip BS time="7:00am" />
          <Note />
          <Trip FI time="7:40am" />
        </Line>
        <Line>
          <Trip BS time="10:00am" />
          <Note leftArrow rightArrow text="Mon & Fri. Only" />
          <Trip FI time="10:40am" />
        </Line>
        <Line>
          <Trip BS time="10:00am" />
          <Note leftArrow rightArrow text="Tues. - Thurs. Only" />
          <Trip FI time="1:10pm" />
        </Line>
        <Line>
          <Trip BS time="12:30pm" />
          <Note leftArrow rightArrow text="Mon. & Fri. Only, Also Runs 12/24" />
          <Trip FI time="1:10pm" />
        </Line>
        <Line>
          <Trip BS time="3:30pm" />
          <Note leftArrow rightArrow text="Does Not Run 12/24" />
          <Trip FI time="4:15pm" />
        </Line>
      </Panel>
      <Panel title="Saturday-Sunday" beach={beach}>
        <Line>
          <Trip BS time="9:30am" />
          <Note />
          <Trip FI time="12:00pm" />
        </Line>
        <Line>
          <Trip BS time="2:50pm" />
          <Note leftArrow rightArrow text="Starts 12/5" />
          <Trip FI time="3:35pm" />
        </Line>
        <Line>
          <Trip BS time="3:30pm" />
          <Note leftArrow rightArrow text="Last Trip 11/29" />
          <Trip FI time="4:15pm" />
        </Line>
      </Panel>
      <Panel title="Thanksgiving Day, 11/26" beach={beach}>
        <Line>
          <Trip BS time="10:00am" />
          <Note />
          <Trip FI time="10:40am" />
        </Line>
      </Panel>
    </Schedule>

    <div className="container mb-5 d-print-none">
      <ServiceNotice />
      <PassengerFreightPolicy />
      <FreightRestrictions />
    </div>
  </div>
);
